module.exports = __webpack_public_path__ + "img/ruoyi5.68e847a5.png";